import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Typography, { TypographyProps } from '@material-ui/core/Typography';
import cx from 'clsx';

const useStyles = makeStyles<Theme>((theme: Theme) => {
  return {
    root: {
      width: '100%',
      minHeight: 104,
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.common.white,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    },
    title: {
      justifyContent: 'center',
      alignItems: 'center',
      display: 'flex',
      minHeight: 100,
      paddingLeft: theme.spacing(6)
    }
  };
});

export interface StepDetailProps extends React.DelHTMLAttributes<HTMLDivElement> {
  typographyProps?: Omit<TypographyProps, 'children'>;
  variant?: 'title';
}

const StepDetail: React.FC<StepDetailProps> = ({
  children,
  className,
  variant,
  typographyProps,
  ...rest
}) => {
  const classes = useStyles();
  const variantProps: TypographyProps & { component?: React.ElementType } =
    variant === 'title' ? { variant: 'h2', component: 'h1' } : {};
  const containerClass = variant === 'title' ? classes.title : classes.root;
  return (
    <div className={cx(containerClass, className)} {...rest}>
      <Typography {...variantProps} {...typographyProps}>
        {children}
      </Typography>
    </div>
  );
};

export default StepDetail;
